var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.16 296.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#310000;}.cls-2{fill:#810000;}.cls-3{fill:#c2fb3b;}.cls-4{fill:#9cdd05;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 7ok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,12.08.38,295.62c0,6.67,21.47-68.62,58-127,51.74-82.67,133.52-99.48,113-120C136.38,13.62,12.08,0,12.08,0A12.08,12.08,0,0,0,0,12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.08.07A12.08,12.08,0,0,0,0,12.15V174.51c13.25-31.91,36-72,68.82-80.2,45.5-11.38,57.84-36.57,75.06-94.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217,129l-21.29-21.29a7.53,7.53,0,0,0-10.65,0l-48.64,48.64L109,183.73,87.74,162.44a7.52,7.52,0,0,0-10.65,0L55.81,183.73a7.52,7.52,0,0,0,0,10.64l47.89,47.9a7.54,7.54,0,0,0,10.65,0l22-22L217,139.66A7.53,7.53,0,0,0,217,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.7,242.27a7.54,7.54,0,0,0,10.65,0l22-22V156.37L109,183.73,87.74,162.44a7.52,7.52,0,0,0-10.65,0L55.81,183.73a7.52,7.52,0,0,0,0,10.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/BG_1.e9834583491ad6f042d65227d99fc77c.svg";
export { ForwardRef as ReactComponent };